var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button__container pointer",on:{"click":_vm.nav}},[_vm._m(0),_c('span',[_vm._v("Back")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button__arrow-block"},[_c('div',{staticClass:"back-button__arrow-box"},[_c('i',{staticClass:"arrow left"})])])
}]

export { render, staticRenderFns }